export const getStyles = () => {
    const styles = {
        createBtn: {
            borderRadius: '10px',
            color: '#FFFFFF',
            fontWeight: 600,
            backgroundColor: '#F1594E',
            textTransform: 'none',
            '&:hover': {
                backgroundColor: '#d85046'
            }
        },
        progressWrapper: {
            height: "calc(100dvh - 75px - 16px - 42px - 80px - 32px - 16px)",

            justifyContent: 'center',
            alignItems: 'center'
        }
    };
    return styles;
};